"use strict";

exports.__esModule = true;
exports["default"] = void 0;

/**
 * Created by madura on 3/3/17.
 */
var _default = {
  'default': {
    'email-wrapper': {
      'backgroundColor': '#f2f2f2',
      'padding': '5px 5px 5px 5px',
      'fontFamily': 'Helvetica'
    },
    'email-wrapper-content': {
      'backgroundColor': '#ffffff',
      'fontSize': '16px'
    },
    'title-content': {
      'padding': '10px 20px 0px 20px',
      'lineHeight': '30px',
      'textAlign': 'left',
      'color': '#626262'
    },
    'text-content': {
      'padding': '0px 20px 0px 20px',
      'lineHeight': '26px',
      'textAlign': 'left',
      'color': '#626262'
    },
    'content-block': {
      'margin': '20px 20px 20px 20px',
      'textAlign': 'center'
    },
    'image-wrap-medium': {
      'padding': '10px 20px 10px 20px'
    },
    'image-wrap-small': {
      'padding': '10px 20px 10px 20px',
      'textAlign': 'center'
    },
    'image-big': {
      'width': '100%'
    },
    'image-medium': {
      'width': '75%'
    },
    'image-small': {
      'width': '50%'
    },
    'video-wrap': {
      'padding': '10px',
      'margin': '10px',
      'position': 'relative',
      'background': '#eee',
      'display': 'inline-block',
      'transition': 'background-color 0.5s ease'
    },
    'video': {
      'textAlign': 'center',
      'maxWidth': '100%',
      'float': 'left'
    },
    'button-wrapper': {
      'padding': '10px 20px 10px 20px'
    },
    'button': {
      'padding': '11px 28px 11px 28px',
      'background': '#006cff',
      'color': '#fff',
      'fontSize': '14px',
      'fontWeight': '500',
      'textDecoration': 'none',
      'border': 'none'
    },
    'button-big': {
      'fontSize': '16px',
      'padding': '16px 40px 16px 40px'
    },
    'button-small': {
      'fontSize': '12px',
      'padding': '8px 16px 8px 16px'
    },
    'text-center': {
      'textAlign': 'center'
    },
    'align-left': {
      'textAlign': 'left'
    },
    'align-center': {
      'textAlign': 'center'
    },
    'align-right': {
      'textAlign': 'right'
    },
    'align-justify': {
      'textAlign': 'justify'
    },
    'title': {
      'fontSize': '30px',
      'lineHeight': '30px',
      'margin': '0'
    },
    'sub-title': {
      'fontSize': '24px',
      'lineHeight': '24px',
      'margin': '0'
    },
    'text': {
      'fontSize': '16px',
      'lineHeight': '26px'
    },
    'code': {
      'backgroundColor': 'rgba(0, 0, 0, 0.05)',
      'fontSize': '16px',
      'padding': '2px'
    },
    'code-block': {
      'backgroundColor': 'rgba(0, 0, 0, 0.05)',
      'fontSize': '16px',
      'padding': '20px'
    },
    'blockquote': {
      'borderLeft': '2px solid #ddd',
      'color': '#999',
      'fontStyle': 'italic',
      'margin': '12px 0 40px 0',
      'padding': '6px 0 5px 18px'
    },
    'unsubscribe-link': {
      'color': '#8e8e8e',
      'textAlign': 'center',
      'fontSize': '10px',
      'paddingTop': '5px',
      'paddingBottom': '10px'
    },
    'social-medial-wrapper': {
      textAlign: 'center',
      margin: '5px 0px 5px 0px'
    },
    'social-media-icon': {
      height: '32px',
      width: '32px',
      padding: '10px 10px 0px 10px'
    },
    'social-media-icon-small': {
      height: '24px',
      width: '24px',
      padding: '10px 10px 0px 10px'
    },
    'social-media-icon-big': {
      height: '48px',
      width: '48px',
      padding: '15px 10px 0px 10px'
    },
    'social-media-title': {
      color: '#8e8e8e',
      fontSize: '12px'
    },
    'social-media-title-small': {
      color: '#8e8e8e',
      fontSize: '10px'
    },
    'social-media-title-big': {
      color: '#8e8e8e',
      fontSize: '14px'
    },
    'color-red': {
      color: '#900'
    },
    'color-blue': {
      color: 'blue'
    },
    'color-green': {
      color: 'green'
    },
    CUSTOM_ADD_FONT_FAMILY_ONE: {
      fontFamily: 'Arial'
    },
    CUSTOM_ADD_FONT_FAMILY_TWO: {
      fontFamily: 'Arial Black'
    },
    CUSTOM_ADD_FONT_FAMILY_THR: {
      fontFamily: 'Comic Sans MS'
    },
    CUSTOM_ADD_FONT_FAMILY_FUR: {
      fontFamily: 'Courier New'
    },
    CUSTOM_ADD_FONT_FAMILY_FIV: {
      fontFamily: 'Helvetica'
    },
    CUSTOM_ADD_FONT_FAMILY_SIX: {
      fontFamily: 'Impact'
    },
    CUSTOM_ADD_FONT_FAMILY_SVN: {
      fontFamily: 'Lucida Console'
    },
    CUSTOM_ADD_FONT_FAMILY_EGT: {
      fontFamily: 'Lucida Sans Unicode'
    },
    CUSTOM_ADD_FONT_FAMILY_NNE: {
      fontFamily: 'Lucida Grande'
    },
    CUSTOM_ADD_FONT_FAMILY_TEN: {
      fontFamily: 'Palatino Linotype'
    },
    CUSTOM_ADD_FONT_FAMILY_ELE: {
      fontFamily: 'sans-serif'
    },
    CUSTOM_ADD_FONT_FAMILY_TWE: {
      fontFamily: 'Tahoma'
    },
    CUSTOM_ADD_FONT_FAMILY_THT: {
      fontFamily: 'Trebuchet MS'
    },
    CUSTOM_ADD_FONT_FAMILY_FTN: {
      fontFamily: 'Verdana'
    },
    CUSTOM_ADDCOLOR_ONE: {
      color: '#F44336'
    },
    CUSTOM_ADDCOLOR_TWO: {
      'color': '#212121'
    },
    CUSTOM_ADDCOLOR_THR: {
      'color': '#00C853'
    },
    CUSTOM_ADDCOLOR_FUR: {
      'color': '#2979FF'
    },
    CUSTOM_ADDCOLOR_FVE: {
      'color': '#FE9600'
    },
    CUSTOM_ADDCOLOR_SIX: {
      'color': '#B000B0'
    },
    CUSTOM_ADDCOLOR_SVN: {
      'color': '#5A7A8A'
    },
    ALIGN_BLOCK_center: {
      'marginLeft': 'auto',
      'marginRight': 'auto',
      'display': 'block'
    },
    ALIGN_BLOCK_right: {
      'float': 'right',
      'display': 'block'
    },
    ALIGN_BLOCK_left: {
      'float': 'left',
      'display': 'block'
    },
    'footer-wrapper': {
      backgroundColor: 'transparent',
      padding: '5px 5px 5px 5px',
      width: '100%',
      fontSize: '12px',
      textAlign: 'center'
    },
    'footer-td': {
      padding: '5px 5px 5px 5px'
    },
    'footer-social-media-icon-wrapper': {
      width: '100%'
    },
    'footer-social-media-icon': {
      fill: '#212121',
      padding: '5px 5px 5px 5px',
      height: '30px',
      width: '30px',
      display: 'inline-block'
    }
  }
};
exports["default"] = _default;
module.exports = exports.default;